import {
    assistantAsking, assistantAskingForAction,
    assistantAskingForContext, assistantAskingForExample,
    assistantAskingForGenre, assistantAskingForInstructions, assistantAskingForRequirements, assistantAskingForSchema,
    assistantAskingForSynopsis, systemInstruction, userSaying
} from "../../../../../../../ai/Utils";
import {DraftAct, DraftChapter} from "../../../../../../../feature/Draft";


export const generateChaptersPrompt = (vars: {
    act: number,
    genres: string[],
    synopsis: string,
    acts: DraftAct[],
    context?: string[]
}) => systemInstruction("Ты профессиональный писатель")
    .concat(userSaying("Я работаю над созданием литературного произведения"))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Опиши акты акты произведения", JSON.stringify(vars.acts.map((item) => ({
        act: item.id,
        content: item.description
    })))))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        `Проанализируй краткое содержание ${vars.act}-го акта`,
        "Сгенерируй главы, на которые можно разбить акт"
    ]))
    .concat(assistantAskingForRequirements([
        "Действия и события в главах не должны повторяться",
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": [{"id":number, "title":string, "description":string}],}'))
    .concat(assistantAskingForExample({
        data: [
            {
                id: 1,
                title: "Осмотр места преступления",
                description: "Детектив наслаждается пейзажем рядом с местом преступления. После он отправляется на место преступления и разговаривает с криминалистами. Криминалисты рассказывают ему о найденных уликах. У детектива начинает складываться картина произошедшего. Он мысленно составляет психологический портрет преступника. Детектив возвращается в участок"
            }
        ]
    }))
    .concat(assistantAskingForAction(`Сгенерируй главы для ${vars.act}-го акта.`))

export const generateChapterPrompt = (vars: {
    genres: string[],
    synopsis: string,
    chapter: number,
    chapters: DraftChapter[],
    context?: string[]
}) => systemInstruction("Ты профессиональный писатель")
    .concat(userSaying("Я работаю над созданием литературного произведения"))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Опиши все главы произведения", JSON.stringify(vars.chapters.map((item) => ({
        chapter: item.id,
        content: item.description
    })))))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        "Придумай содержимое главы",
        "Проработай содержимое главы"
    ]))
    .concat(assistantAskingForRequirements([
        "Объем текста должен оставаться таким же как в исходной главе",
        "События не должны пересекаться с другими главами",
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": {"id":number, "title":string, "description":string}'))
    .concat(assistantAskingForExample({
        data: {
            id: 1,
            title: "Находка",
            description: "- В ночь на 31 декабря главный герой отправляется в поход и находит магический артефакт.\\n\\nОн приносит артефакт домой и замечает изменения вокруг себя.\\n\\nОн решает исследовать артефакт"
        }
    }))
    .concat(assistantAskingForAction(`Перегенерируй существующую или сгенерируй новую ${vars.chapter}-ю главу истории.`))

export const improveChapterPrompt = (vars: {
    chapter: DraftChapter,
    genres: string[],
    synopsis: string,
    chapters: DraftChapter[],
    context?: string[]
}) => systemInstruction("Ты профессиональный писатель")
    .concat(userSaying("Я работаю над созданием литературного произведения"))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Опиши все главы акта", JSON.stringify(vars.chapters.map((item) => ({
        chapter: item.id,
        content: item.description
    })))))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        `Проанализируй краткое содержание ${vars.chapter.id}-й главы`,
        "Наполни главу деталями, чтобы разнообразить сюжет",
        "Добавь действия и события, которые могут произойти в главе",
        "Можно добавить вне сюжетные события, истории, рассказы, если это необходимо для раскрытия смысла или объяснения неочевидных моментов",
        "Убедись, что добавленные действия и события соответствуют содержимому главы",
        "Убедись, что добавленные действия и события не забегают вперед по сюжету",
        "Разбей содержимое главы на абзацы"
    ]))
    .concat(assistantAskingForRequirements([
        "Действия и события в главах не должны повторяться",
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": {"id":number, "title":string, "description":string}'))
    .concat(assistantAskingForExample({
        data: {
            id: 1,
            title: "Осмотр места преступления",
            description: "Детектив наслаждается пейзажем рядом с местом преступления. После он отправляется на место преступления и разговаривает с криминалистами. Криминалисты рассказывают ему о найденных уликах. У детектива начинает складываться картина произошедшего. Он мысленно составляет психологический портрет преступника. Детектив возвращается в участок"
        }
        }))
    .concat(assistantAskingForAction(`Наполни ${vars.chapter.id}-ю главу.`))